var exports = {
  "kL": "xa15a2ab7--b220a6--container",
  "Qs": "xa15a2ab7--b220a6--content",
  "kb": "xa15a2ab7--b220a6--left",
  "pG": "xa15a2ab7--b220a6--right",
  "WL": "xa15a2ab7--b220a6--factoids",
  "PD": "xa15a2ab7--b220a6--developer",
  "I3": "xa15a2ab7--b220a6--developer-preview",
  "m4": "xa15a2ab7--b220a6--developer-subtitle",
  "iF": "xa15a2ab7--b220a6--developer-title",
};

module.exports = exports;
